import { hasInvalidCharacters, profane, unique, } from 'const/usernames'
import A from 'const/actionTypes'
import actions from 'actions'
import commonPasswords from 'const/commonPasswords'

const testBio = (bio) => {
  let bioError = null

  if (bio) {
    if (typeof bio !== 'string') {
      bioError = 'Invalid Format'
    } else if (bio.length > 250) {
      bioError = 'Must Be 250 Or Fewer Characters'
    } else {
      const profaneMatches = profane(bio)
      if (profaneMatches.length) {
        bioError = `Profanity Is Not Allowed: '${profaneMatches.join("', '")}'`
      }
    }
  }
  return bioError
}

const testEmail = (email) => {
  let emailError
  const expression = /\S+@\S+\.\S+/
  // TODO - consider using Regex below to minimize invalid email signups
  // const expression = new RegExp(['^(([^<>()[\]\\.,;:\\s@\"]+(\\.[^<>(),[\]\\.,;:\\s@\"]+)*)',
  //   '|(\\".+\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.',
  //   '[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\\.)+',
  //   '[a-zA-Z]{2,}))$'].join(''))

  if (!expression.test(email) && email) {
    emailError = 'Need a valid email address'
  } else {
    emailError = null
  }

  return emailError
}

const testFavoriteGame = (game) => {
  let favoriteGameError = null

  if (game) {
    if (typeof game !== 'string') {
      favoriteGameError = 'Invalid Format'
    } else if (game.length > 130) {
      favoriteGameError = 'Must Be 250 Or Fewer Characters'
    } else {
      const profaneMatches = profane(game)
      if (profaneMatches.length) {
        favoriteGameError = `Profanity Is Not Allowed: '${profaneMatches.join("', '")}'`
      }
    }
  }
  return favoriteGameError
}

const testString = (string, maxLength) => {
  let error = null

  if (string) {
    if (typeof string !== 'string') {
      error = 'Invalid Format'
    } else if (string.length > maxLength) {
      error = `Must Be ${maxLength} Or Fewer Characters`
    } else {
      const profaneMatches = profane(string)
      if (profaneMatches.length) {
        error = `Profanity Is Not Allowed: '${profaneMatches.join("', '")}'`
      }
    }
  }

  return error
}

const testUsername = (username) => {
  let usernameError = null

  if (username) {
    if (typeof username !== 'string') {
      usernameError = 'Invalid Format'
    } else if (username.length > 25) {
      usernameError = 'Must Be 25 Or Fewer Characters'
    } else if (hasInvalidCharacters(username)) {
      usernameError = "Invalid Characters. '.' Is Not Allowed."
    } else {
      const profaneMatches = profane(username)
      if (profaneMatches.length) {
        usernameError = `Profanity Is Not Allowed: '${profaneMatches.join("', '")}'`
      } else {
        return unique(username).then(uniqueUsername => {
          if (!uniqueUsername) {
            usernameError = `Username '${username}' Is Taken. Try Another`
          }
          return usernameError
        })
      }
    }
  }
  return new Promise((resolve, reject) => {
    resolve(usernameError)
  })
}

export default {
  clearUserInterface: () => {
    return (dispatch, getState) => {
      dispatch(actions.updateUserInterface({
        activeGameTab: 0,
        activeTab: 1,
        bio: null,
        confirmNewPassword: null,
        confirmNewPasswordError: null,
        confirmPassword: null,
        confirmPasswordError: null,
        email: null,
        error: null,
        favoriteGame: null,
        featureRequest: null,
        featureRequestError: null,
        fullName: null,
        isReadyToSignIn: false,
        isReadyToSignUp: false,
        isReadyToUpdateEmail: false,
        isReadyToUpdatePassword: false,
        isReadyToSendSupporMessage: false,
        newEmail: null,
        newPassword: null,
        newPasswordError: null,
        password: null,
        passwordError: null,
        supportMessage: null,
        supportMessageError: null,
        username: null,
      }))
    }
  },
  updateUserInterface: (update) => {
    return (dispatch, getState) => {
      dispatch({
        type: A.UPDATE_USER_INTERFACE,
        update,
      })
      const userInterface = getState().userInterface

      let error = null // wipe out Identity Provider Errors
      let password = userInterface.password
      let passwordError
      if (password && password.length < 8) {
        passwordError = 'Password needs to be 8 characters'
      } else if (password && commonPasswords.indexOf(password) > -1) {
        passwordError = `${password} is too easy to guess`
      } else if (password && password.length > 64) {
        passwordError = 'Password needs to be 64 or fewer characters'
      } else {
        passwordError = null
      }

      let confirmPasswordError
      if (password && (password !== userInterface.confirmPassword)) {
        confirmPasswordError = 'Make sure passwords match'
      } else {
        confirmPasswordError = null
      }

      let isReadyToSignIn
      if (
          !passwordError &&
          !userInterface.emailError &&
          userInterface.password &&
          userInterface.email
      ) {
        isReadyToSignIn = true
      } else {
        isReadyToSignIn = false
      }

      let isReadyToSignUp
      if (
          !passwordError &&
          !confirmPasswordError &&
          !userInterface.emailError &&
          userInterface.password &&
          userInterface.email &&
          !userInterface.usernameError
      ) {
        isReadyToSignUp = true
      } else {
        isReadyToSignUp = false
      }

      // REFACTOR out to updateAccountUserInterface action?
      let newPasswordError
      if (userInterface.newPassword && (userInterface.newPassword.length < 6)) {
        newPasswordError = 'Password needs to be 6 characters'
      } else {
        newPasswordError = null
      }

      let confirmNewPasswordError
      if (userInterface.newPassword && (userInterface.newPassword !== userInterface.confirmNewPassword)) {
        confirmNewPasswordError = 'Make sure passwords match'
      } else {
        confirmNewPasswordError = null
      }

      let isReadyToUpdatePassword
      if (
        !newPasswordError &&
        !confirmNewPasswordError &&
        userInterface.newPassword
      ) {
        isReadyToUpdatePassword = true
      } else {
        isReadyToUpdatePassword = false
      }

      let isReadyToUpdateEmail
      if (
        !userInterface.newEmailError &&
        userInterface.newEmail
      ) {
        isReadyToUpdateEmail = true
      } else {
        isReadyToUpdateEmail = false
      }

      let isReadyToUpdateResetEmail
      if (
        !userInterface.resetEmailError &&
        userInterface.resetEmail
      ) {
        isReadyToUpdateResetEmail = true
      } else {
        isReadyToUpdateResetEmail = false
      }

      let isReadyToSendFeatureRequest
      let featureRequestError
      if (!userInterface.featureRequest) {
        featureRequestError = 'Please enter a message'
        isReadyToSendFeatureRequest = false
      } else {
        featureRequestError = null
        isReadyToSendFeatureRequest = true
      }

      let isReadyToSendSupporMessage
      let supportMessageError
      if (!userInterface.supportMessage) {
        supportMessageError = 'Please enter a message'
        isReadyToSendSupporMessage = false
      } else {
        supportMessageError = null
        isReadyToSendSupporMessage = true
      }

      dispatch({
        type: A.UPDATE_USER_INTERFACE,
        update: {
          confirmNewPasswordError,
          confirmPasswordError,
          error,
          featureRequestError,
          isReadyToSignIn,
          isReadyToSendFeatureRequest,
          isReadyToSendSupporMessage,
          isReadyToSignUp,
          isReadyToUpdateEmail,
          isReadyToUpdatePassword,
          isReadyToUpdateResetEmail,
          newPasswordError,
          passwordError,
          supportMessageError,
        },
      })
    }
  },
  validateBio: () => {
    return (dispatch, getState) => {
      const bio = getState().userInterface.bio
      const bioError = testBio(bio)
      dispatch(actions.updateUserInterface({ bioError: bioError }))
      return bioError
    }
  },
  validateEmail: () => {
    return (dispatch, getState) => {
      const email = getState().userInterface.email
      const emailError = testEmail(email)
      dispatch(actions.updateUserInterface({ emailError: emailError }))
    }
  },
  validateFavoriteGame: () => {
    return (dispatch, getState) => {
      const game = getState().userInterface.favoriteGame
      const favoriteGameError = testFavoriteGame(game)
      dispatch(actions.updateUserInterface({ favoriteGameError: favoriteGameError }))
      return favoriteGameError
    }
  },
  validateFullName: () => {
    return (dispatch, getState) => {
      const fullName = getState().userInterface.fullNname
      const fullNameError = testString(fullName, 200)
      dispatch(actions.updateUserInterface({ fullNameError: fullNameError }))
    }
  },
  validateLocation: () => {
    return (dispatch, getState) => {
      const location = getState().userInterface.location
      const locationError = testString(location, 50)
      dispatch(actions.updateUserInterface({ locationError: locationError }))
    }
  },
  validateNewEmail: () => {
    return (dispatch, getState) => {
      const newEmail = getState().userInterface.newEmail
      const newEmailError = testEmail(newEmail)
      dispatch(actions.updateUserInterface({ newEmailError: newEmailError }))
    }
  },
  validateResetEmail: () => {
    return (dispatch, getState) => {
      const resetEmail = getState().userInterface.resetEmail
      const resetEmailError = testEmail(resetEmail)
      dispatch(actions.updateUserInterface({ resetEmailError: resetEmailError }))
    }
  },
  validateUsername: () => {
    return (dispatch, getState) => {
      const username = getState().userInterface.username
      return testUsername(username).then(usernameError => {
        dispatch(actions.updateUserInterface({ usernameError: usernameError }))
        return usernameError
      })
    }
  },
}



// WEBPACK FOOTER //
// ./src/app/actions/userInterface.js